import { safeApiRequest } from './apiClient';

/**
 * Teknik servis ID'sine göre teknisyenleri listele
 */
export const fetchTechniciansByTechService = async (teknikServisId, { aktif = true } = {}) => {
  if (!teknikServisId) {
    throw new Error('Teknik servis ID gereklidir');
  }
  const queryParams = {};

  if (aktif === 'all') {
    queryParams.aktif = 'all';
  } else if (aktif === false) {
    queryParams.aktif = 'false';
  }

  return safeApiRequest(`/api/tech-services/${teknikServisId}/technicians`, {
    method: 'GET',
    query: queryParams,
    skipCsrf: true,
  });
};


